import {
  ENTITY_CLASS,
  type FacilityKey,
  type OrganizationKey,
  type UserKey,
  isUserKey,
} from "@packages/core";
import { useQuery } from "@tanstack/react-query";

import { fetchData } from "./functions";
import { QueryKey } from "./query";

export async function findOperator(
  userKey: FacilityKey | OrganizationKey | UserKey | false | null | undefined,
) {
  if (!isUserKey(userKey)) {
    return undefined;
  }
  const { output } = await fetchData({ type: "Entity::Operator", input: { userKey } });
  if (output instanceof Error) {
    throw output;
  } else {
    return output;
  }
}

function OperatorQueryKey(
  userKey: FacilityKey | OrganizationKey | UserKey | false | null | undefined,
) {
  return QueryKey(ENTITY_CLASS.OPERATOR, userKey);
}

/** @deprecated 代わりに`useOperatorQuery`を使用する。 */
export function useOperator(
  userKey: UserKey | false | null | undefined,
  options?: {
    /** 仮想化された一覧で表示される場合に`true`を設定するフラグ */
    virtualized?: boolean;
  },
) {
  const { data: operator } = useQuery({
    enabled: Boolean(userKey),
    queryKey: OperatorQueryKey(userKey),
    async queryFn() {
      return findOperator(userKey);
    },

    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnMount: !options?.virtualized,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 60 * 1000,
  });

  return operator;
}

export function useOperatorQuery(
  userKey: FacilityKey | OrganizationKey | UserKey | false | null | undefined,
) {
  return useQuery({
    queryKey: OperatorQueryKey(userKey),
    async queryFn() {
      return findOperator(userKey);
    },

    enabled: isUserKey(userKey),
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: /** 4時間 */ 14_400_000,
  });
}
